<template>
  <div class="verify-dialog">
    <el-dialog
      title="审核"
      width="30%"
      :visible.sync="myValue"
      :close-on-click-modal="false"
      :show-close="false"
      @close="close"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="审核" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="'1'">审核通过</el-radio>
            <el-radio :label="'2'">审核驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原因" v-if="form.status === '2'" prop="statusRemarks">
          <el-input type="textarea" v-model="form.statusRemarks" :rows="5"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    verifySrc: {
      type: String,
      default: ''
    },
    verifyStatus: {
      type: String,
      default: '1'
    },
    statusRemarks: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      myValue: this.value,
      myId: this.id,
      mySrc: this.verifySrc,
      myStatus: this.verifyStatus,
      myStatusRemarks: this.statusRemarks,
      form: {
        status: this.verifyStatus,
        statusRemarks: this.statusRemarks
      },
      rules: {
        status: [
          {
            required: true
          }
        ],
        statusRemarks: [
          {
            required: true, message: '请填写理由', trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    value (val) {
      this.myValue = val
    },
    id (val) {
      this.myId = val
    },
    verifySrc (val) {
      this.mySrc = val
    },
    verifyStatus (val) {
      console.log(val)
      this.myStatus = val
      this.form.status = val
    },
    statusRemarks (val) {
      this.myStatusRemarks = val
      this.form.statusRemarks = val
    }
  },
  created () {

  },
  mounted () {
  },
  methods: {
    cancel () {
      this.myValue = false
    },
    confirm () {
      this.$refs.form.validate(val => {
        if (val) {
          if (this.form.status === '1') {
            this.form.statusRemarks = ''
          }
          let params = JSON.parse(JSON.stringify(this.form))
          params.id = this.myId
          this.$http.post(this.mySrc, params).then(res => {
            if (res.data.code === '200') {
              this.myValue = false
              this.$message.success(res.data.msg)
            }
          })
        }
      })
    },
    close () {
      this.$emit('input', false)
      this.form = {
        status: '',
        statusRemarks: ''
      }
    }
  }
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/verifyDialog.vue